import React, { useEffect, useState } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Table, TableBody, TableCell, TableHead, TableRow, IconButton
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axios from "axios";
import { getAPIUrl } from "../api/apiUtils";

const API_URL = `${getAPIUrl()}/crud/table/dictionaries`;

export default function DictionariesAdmin() {
  const [dictionaries, setDictionaries] = useState([]);
  const [open, setOpen] = useState(false);
  const [editDict, setEditDict] = useState(null);
  const [form, setForm] = useState({ title: "", words: "" });
  const [wordsModal, setWordsModal] = useState({ open: false, words: [] });

  const fetchDictionaries = async () => {
    try {
      const res = await axios.get(API_URL);
      setDictionaries(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (e) {
      setDictionaries([]);
    }
  };

  useEffect(() => { fetchDictionaries(); }, []);

  const handleOpen = (dict = null) => {
    setEditDict(dict);
    setForm(dict
      ? { title: dict.title, words: Array.isArray(dict.words) ? dict.words.join(", ") : dict.words }
      : { title: "", words: "" }
    );
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditDict(null);
    setForm({ title: "", words: "" });
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    const payload = {
      title: form.title,
      words: form.words
        .split(/[\n,]+/)
        .map(w => w.replace(/[{}]/g, '').trim()) // убираем фигурные скобки
        .filter(w => w)
    };
    try {
      if (editDict) {
        await axios.put(`${API_URL}/${editDict.id}`, payload);
      } else {
        await axios.post(API_URL, payload);
      }
      fetchDictionaries();
      handleClose();
    } catch (error) {
      console.error("Ошибка при сохранении:", error);
      alert("Ошибка при сохранении данных.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Удалить словарь?")) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        fetchDictionaries();
      } catch (error) {
        console.error("Ошибка при удалении:", error);
        alert("Ошибка при удалении данных.");
      }
    }
  };

  const handleShowWords = (words) => {
    setWordsModal({ open: true, words });
  };

  const handleCloseWords = () => {
    setWordsModal({ open: false, words: [] });
  };

  return (
    <div>
      <h2>Словари</h2>
      <Button variant="contained" color="primary" onClick={() => handleOpen()}>Добавить</Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Название</TableCell>
            <TableCell>Слова</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(dictionaries || []).map((dict) => {
            const wordsArr = Array.isArray(dict.words)
              ? dict.words
              : (dict.words || '').split(/[\n,]+/).map(w => w.replace(/[{}]/g, '').trim()).filter(w => w);
            const showMore = wordsArr.length > 5;
            return (
              <TableRow key={dict.id}>
                <TableCell>{dict.id}</TableCell>
                <TableCell>{dict.title}</TableCell>
                <TableCell
                  style={{ maxWidth: 300, whiteSpace: "pre-wrap", cursor: "pointer", color: '#1976d2' }}
                  onClick={() => handleShowWords(wordsArr)}
                  title="Показать все слова"
                >
                  {wordsArr.slice(0, 5).join(", ")}
                  {showMore ? " ...ещё" : ""}
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpen(dict)}><Edit /></IconButton>
                  <IconButton onClick={() => handleDelete(dict.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editDict ? "Редактировать" : "Добавить"} словарь</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Название"
            name="title"
            value={form.title}
            onChange={handleChange}
            fullWidth
            variant="outlined"
          />
          <TextField
            margin="dense"
            label="Слова (через запятую или с новой строки)"
            name="words"
            value={form.words}
            onChange={handleChange}
            fullWidth
            multiline
            minRows={4}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            {editDict ? "Сохранить" : "Добавить"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={wordsModal.open} onClose={handleCloseWords} maxWidth="sm" fullWidth>
        <DialogTitle>Все слова</DialogTitle>
        <DialogContent>
          <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: 400, overflowY: "auto", fontSize: 16, padding: 8 }}>
            {wordsModal.words.join(", ")}
          </div>
          <Button onClick={handleCloseWords} style={{ marginTop: 16 }} variant="outlined" color="primary">Закрыть</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
} 